import React, { Suspense, lazy } from 'react';
import SearchBarSS from '../SearchBar/SearchBarSS';
import DashboardTab from '../DashBoard/DashBoardTab';
import AuthSettings from '../Auth/AuthSettings';
import WhatsAppIcon from '../Social/WhatsAppIcon';
import Loader from '../Loader/Waiting';

const Waiting = lazy(() => import('../Loader/Waiting'));
const ShopAll = lazy(() => import('../DropDown/ShopAll'));
const ModalMenu = lazy(() => import('../Modal/ModalMenu'));
const SearchBarBS = lazy(() => import('../SearchBar/SearchBarBS'));
const OnDemand = lazy(() => import('../DropDown/OnDemand'));
const Recommended = lazy(() => import('../DropDown/Recommended'));
const OurLocations = lazy(() => import('../DropDown/Ourlocations'));
const ContactUs = lazy(() => import('../Contact/ContactUs'));
const SmallScreenSearch = lazy(() => import('../SearchBar/SmallScreenSearch'));
const Footer = lazy(() => import('../Footer/Footer'));


const NotPageFound = () => {
  return (
    <div className='dashboard'>
      <Suspense fallback={<Loader/>}>
        <ModalMenu />
        <SmallScreenSearch />
        <SearchBarBS />
        <SearchBarSS />
        <Waiting />
      </Suspense>
        <DashboardTab />
        <AuthSettings />
        <WhatsAppIcon />
      <Suspense fallback={<Loader/>}>
        <ShopAll />
        <OnDemand />
        <Recommended />
        <OurLocations />
        <ContactUs />
      </Suspense>
      <div className='page-not-found-content'>
        <p>Page not found.</p>
      </div>
      <Suspense fallback={<Loader/>}>
        <Footer />
      </Suspense>
    </div>
  )
}

export default NotPageFound;
